/**
 * Playwright-Bot: Live oder Staging — gemeinsame Wahrheit für Server und UI
 * (06.10.2026).
 *
 * Der Seitenscanner (mso-ai-libs auf dem Root-Server) läuft zweimal: als
 * Live-Dienst und als Staging-Dienst. Welcher für eine Umgebung (INT, Sta,
 * Prod) gilt, entscheidet ein Admin-Schalter je Datenbank-Umgebung
 * (`app_settings`, Schlüssel `playwright_target`). Standard ist Live; wer auf
 * Staging testet, stellt die ganze Umgebung um — alle Scan-Anstöße dieser
 * Umgebung (Domain-Screener, Watchdog Raw Run, Discovery, GTM-Analyst) tragen
 * dann `playwright_target: 'staging'`.
 *
 * Der Screener schickt an n8n das WORT, nie die Adresse: n8n (Node „Prepare
 * Context", gehärtete Fassung seit 21.09.2026) bildet `live`/`staging` auf
 * seine zwei festen Adressen ab. Die Adressen in der Screener-.env
 * (PLAYWRIGHT_BASE_LIVE / PLAYWRIGHT_BASE_STAGING) dienen der Anzeige und
 * reisen zusätzlich als `playwright_base` mit — für eine n8n-Fassung, die das
 * Feld noch liest.
 */

export type PlaywrightTarget = 'live' | 'staging';

export const PLAYWRIGHT_TARGETS: PlaywrightTarget[] = ['live', 'staging'];

/** Ohne Eintrag in app_settings gilt der Live-Bot. */
export const DEFAULT_PLAYWRIGHT_TARGET: PlaywrightTarget = 'live';

/** Schlüssel in `app_settings` (höchstens 50 Zeichen). */
export const PLAYWRIGHT_TARGET_SETTING_KEY = 'playwright_target';

export const PLAYWRIGHT_TARGET_LABEL: Record<PlaywrightTarget, string> = {
  live: 'Live',
  staging: 'Staging',
};

export function isPlaywrightTarget(value: unknown): value is PlaywrightTarget {
  return typeof value === 'string' && (PLAYWRIGHT_TARGETS as string[]).includes(value);
}

/** Antwort von GET/PUT /api/admin/playwright-bot. */
export interface PlaywrightBotStatus {
  target: PlaywrightTarget;
  /** `default`, solange in dieser Umgebung nichts hinterlegt ist. */
  source: 'app_settings' | 'default';
  /** Die Adresse, die für `target` in der .env steht — null = nicht hinterlegt. */
  base_url: string | null;
  urls: Record<PlaywrightTarget, string | null>;
  /** Die Datenbank-Umgebung, für die der Schalter gilt. */
  db_profile: string;
}
